export default "__VITE_ASSET__be80ac95__"